import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { BusyService } from '../_services/busy.service';
import { delay, finalize } from 'rxjs/operators';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  constructor(private busyService:BusyService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let ishideloader = request.params.get('ishideloader');
    if(ishideloader!=null){
        ishideloader=ishideloader.toString();
    }
    if (ishideloader == null || ishideloader=="false") {
        this.busyService.busy();
    }
    return next.handle(request).pipe(
      delay(200),
      finalize(()=>{
        this.busyService.idle();
      }) 
    );
  }
}
